export { CollectionsIcon } from "./collections";
